/**
 * email-copy-tracking.js — mide a quien COPIA el email de contacto en vez de
 * hacer clic en el enlace mailto, para contarlo como conversión en Google Ads.
 *
 * Emite a dataLayer (contenedor en snippets/google-tag-manager.liquid):
 *   { event: 'email_copiado', email_copiado: '<el email detectado>' }
 *
 * Escucha a nivel de document, así que cubre el email esté donde esté —barra
 * superior, menú móvil, footer, página de contacto, fichas de producto, páginas
 * legales— y en los tres idiomas, sin tocar ninguna sección. Da igual que el
 * texto copiado venga de dentro de un enlace mailto: getSelection() devuelve el
 * texto visible, que es el propio email.
 *
 * LÍMITE CONOCIDO: el menú contextual del navegador sobre un enlace mailto
 * ("Copiar dirección de correo electrónico") NO dispara ningún evento 'copy' en
 * la página — lo resuelve el navegador por su cuenta. Ese caso es indetectable
 * desde el theme. Sí se detecta seleccionar el texto y copiar (Ctrl/Cmd+C o
 * clic derecho → Copiar sobre la selección).
 *
 * Ver docs/ARCHITECTURE_analytics.md.
 */
(function () {
  'use strict';

  var EMAIL_RE = /[a-z0-9._%+-]+@surisa\.es/i;
  var CLAVE = 'surisa:email-copiado';
  var enviadoEnMemoria = false; // Respaldo si sessionStorage no está disponible.

  function yaSeEnvio() {
    try {
      return window.sessionStorage.getItem(CLAVE) === '1';
    } catch (e) {
      return enviadoEnMemoria; // Navegación privada, cookies bloqueadas, iframe…
    }
  }

  function marcarEnviado() {
    enviadoEnMemoria = true;
    try {
      window.sessionStorage.setItem(CLAVE, '1');
    } catch (e) {
      /* Sin almacenamiento, el tope de una vez por sesión lo sostiene la variable. */
    }
  }

  // Oyente pasivo: ni preventDefault ni escritura en el portapapeles. La copia
  // del usuario sigue su curso exactamente igual que sin este script.
  document.addEventListener('copy', function () {
    if (yaSeEnvio()) return;

    var seleccion = '';
    try {
      seleccion = window.getSelection().toString();
    } catch (e) {
      return;
    }

    var encontrado = seleccion.match(EMAIL_RE);
    if (!encontrado) return;

    marcarEnviado();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'email_copiado',
      metodo: 'manual', // Copia a mano; reservado por si algún día hay un botón.
      email_copiado: encontrado[0].toLowerCase()
    });
  });
})();
